
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../redux/AppStore";
import React, { useEffect, useState } from "react";
import { GetThemeCssThunk } from "../redux/slice/TrackingSlice";
import { hostLogo } from "./trackingSettings";
export default function TrackingHeaders() {
    const companyInfo = useSelector((state: RootState) => state.tracking.companyinfo);
    return (
        <>
        <html lang="en">
            {/* <body> */}
            <head>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <title>Insta Tracking</title>
                <link rel="icon" type="image/png" href="img/Instadispatch_Logo_Icon.png" />
                <link href="css/bootstrap.min.css" rel="stylesheet" />
                <link href="css/style.css" rel="stylesheet" />
                <link href="css/responsive.css" rel="stylesheet" />
                <SiteTheme />
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css" />
            </head>
            <body>
                <div className="navbar fixed-top bg-body-tertiary controling_top">
                    <div className="navbrand_container">
                        <div className="top_columns_container">
                            {(hostLogo() || (companyInfo && companyInfo.logo !== undefined)) && (
                                <div className="left_columns">
                                    <a className="navbar-brand" href="#">
                                        <img
                                            src={
                                                hostLogo() ||
                                                (typeof companyInfo?.logo === "string" && companyInfo.logo.trim() !== ""
                                                    ? companyInfo.logo
                                                    : "img/Instadispatch Logo.png")
                                            }
                                        />
                                    </a>
                                </div>
                            )}

                            <div className="center_columns"></div>
                            <div className="right_columns">
                                {/* BR-1929: company name and working hours, as the old page's company panel showed; the
                                    email link had an empty mailto. */}
                                {companyInfo != null && companyInfo.company_name &&
                                    <span className="company_name"><b>{companyInfo.company_name}</b></span>
                                }
                                {companyInfo != null && companyInfo.support_email &&
                                    <span><a href={`mailto:${companyInfo.support_email}`}>{companyInfo.support_email}</a></span>
                                }
                                {companyInfo != null &&
                                    <span>{companyInfo.support_phone}</span>
                                }
                                {companyInfo != null && companyInfo.support_hours &&
                                    <span className="support_hours">{companyInfo.support_hours}</span>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </body>
        </html>
        </>
    );
}
const SiteTheme: React.FC<any> = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [siteAddress, setSiteAddress] = useState<string>('');
    useEffect(() => {
        setSiteAddress(window.location.href);
    }, []);
    useEffect(() => {
        dispatch(
            GetThemeCssThunk({
                endpoint: "getclientcss",
                domain: window.location.href.replace(/track$/, ''),
            }))
    }, []);
    const css = useSelector((state: RootState) => state.tracking.themecss);
    const cleanSiteAddress = siteAddress.replace(/track$/, '');
    return (
        <>
            {css && css['tracking_domain'] && cleanSiteAddress.includes(css['tracking_domain']) &&
                <link rel="stylesheet" href={css['tracking_root_path']} />}
        </>
    );
}
